import { render, staticRenderFns } from "./freightInquiryDetail.vue?vue&type=template&id=6f231488&scoped=true"
import script from "./freightInquiryDetail.vue?vue&type=script&lang=js"
export * from "./freightInquiryDetail.vue?vue&type=script&lang=js"
import style0 from "./freightInquiryDetail.vue?vue&type=style&index=0&id=6f231488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f231488",
  null
  
)

export default component.exports